export default __webpack_public_path__ + "static/media/UI_ButtonSubtract.09324f05.png";